import type { AuthConfigResponse, AuthMeResponse, TelegramLoginPayload } from '@ayub/shared'
import { apiGet, apiPost } from '@/lib/api'

/**
 * `GET /api/auth/config` — auth TALAB QILINMAYDI (login sahifasi hali sessiyasiz).
 * Faqat Login Widget uchun kerakli bot username'ini beradi.
 */
export function fetchAuthConfig(): Promise<AuthConfigResponse> {
  return apiGet<AuthConfigResponse>('/auth/config')
}

/** `GET /api/auth/me` — joriy sessiya egasi. Sessiya yo'q/eskirgan bo'lsa 401 (`ApiError`). */
export function fetchAuthMe(): Promise<AuthMeResponse> {
  return apiGet<AuthMeResponse>('/auth/me')
}

/**
 * `POST /api/auth/telegram` — Login Widget qaytargan ma'lumotni serverga yuboradi.
 * Muvaffaqiyatli bo'lsa server `Set-Cookie` bilan sessiya o'rnatadi va joriy adminni
 * qaytaradi (`GET /api/auth/me` bilan bir xil shakl).
 */
export function loginWithTelegram(payload: TelegramLoginPayload): Promise<AuthMeResponse> {
  return apiPost<AuthMeResponse>('/auth/telegram', payload)
}

/** `POST /api/auth/logout` — sessiya cookie'sini o'chiradi. Javob tanasi yo'q. */
export function logoutRequest(): Promise<void> {
  return apiPost<void>('/auth/logout')
}
